import React from 'react';
import PropTypes from 'prop-types';
import {EMPTY_OBJECT} from '../../constants';
import Style from '../Style';
import { H6 } from '../Typography';

class LicenseMeter extends React.PureComponent {
  static propTypes = {
    used: PropTypes.number,
    max: PropTypes.number,
    style: PropTypes.object,
    textStyle: PropTypes.object,
    meterStyle: PropTypes.object,
  };
  static defaultProps = {
    style: EMPTY_OBJECT,
    textStyle: EMPTY_OBJECT,
  };

  render() {
    const {
      used,
      max,
      style,
      textStyle,
      meterStyle,
      ...otherProps,
    } = this.props;

    let message = 'Unlimited';
    let remaining = max;
    if (max >= 0) {
      remaining = Math.max(0, max - used);
      message = `${remaining} of ${max}`;
    }
    if(used === undefined && max === undefined) {
      message = '0'
    }

    return (
      <div
        style={{
          position: 'relative',
          height: '100%',
          width: '100%',
          border: `0.3rem solid ${Style.Colors.black}`,
          borderRadius: '99999rem',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          ...style
        }}
      >
        <H6 style={{ ...textStyle, zIndex: 1 }}>{message}</H6>
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 0,
            height: '100%',
            width: `${remaining / max * 100}%`,
            borderRadius: '99999rem',
            backgroundColor: Style.Colors.shadow5,
            ...meterStyle,
          }}
        />
      </div>
    );
  }
}

export default LicenseMeter;

export function remaining(used, max) {
  let count = 'Unlimited';
  let remaining = max;
  if (max >= 0) {
    count =  Math.max(0, max - used);
  }
  if(used === undefined && max === undefined) {
    count = 0;
  }

  return count;
}



// WEBPACK FOOTER //
// ./src/components/LicenseMeter/LicenseMeter.js